<template>
  <div class="container">
    <content-template>
      <template slot="left">{{activity.name}}</template>
      <template slot="right">
        <li>
          <a class="is-check" style="color: #5571EC;">簡介及比賽規章</a>
        </li>
        <li>
          <router-link :to="{path:'online-enroll',query:{id:activity.id}}">線上報名</router-link>
        </li>
        <li>
          <router-link :to="{path:'activity-works',query:{id:activity.id}}">比賽作品</router-link>
        </li>
      </template>
      <template slot="banner">
        <div class="col-xs-12 activity-bg none-padding" style="text-align: center;">
          <img :src="activity.banner_url" style="padding:0px;max-width: 100%" alt="">
        </div>
      </template>
      <template slot="content">

        <div class="row" style="padding:0px;">
          <span class="col-xs-6 news-title">簡介及比賽 </span>
          <!--<span class=" col-xs-6 ac-time">-->
            <!--報名日期:{{activity.register_start_time|moment("YYYY年MM月DD日")}}-->
            <!--至{{activity.register_end_time|moment("MM月DD日")}}-->
          <!--</span>-->
          <span class=" col-xs-6 ac-time">
            報名日期:{{activity.register_start_time * 1000|datefmt("YYYY年MM月DD日")}}
            至{{activity.register_end_time * 1000|datefmt("YYYY年MM月DD日")}}
          </span>
        </div>
        <div class="col-xs-12">
          <div v-html="activity.rule"></div>
        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'

export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      activity: [],
      activityId: ''
    }
  },
  methods: {
    // 根据活动id获取活动
    getActivity: function () {
      this.activityId = this.$route.query.id
      var that = this
      this.$axios.get('/activity/' + this.activityId)
        .then(function (response) {
          that.activity = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  watch: {
    $route () {
      this.getActivity()
    }
  },
  mounted () {
    this.getActivity()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  /*.ac-time {*/
    /*text-align: right;*/
    /*font-size: 16px;*/
    /*color: #565656;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/activity/index.vue